<template>
    <b-card no-body class="py-2 px-3">
        <b-row>
            <b-col class="border-right">
                <p>Disbursement Status</p>
                <h4 :class="currentStatus.color_class">{{ currentStatus.name }}</h4>
            </b-col>
            <b-col class="border-right">
                <p>Full Disbursement Date</p>
                <!-- <h4>{{ _gHlp.formatMomentDate(activeCase.disb_tat_date, 'D MMM, YYYY') }}</h4> -->
                <h4>{{ _gHlp.formatMomentDate(activeCase.disb_full_date, 'D MMM, YYYY') }}</h4>
            </b-col>
            <b-col class="border-right">
                <p>Settlement Amt. (RM)</p>
								<h4>{{ activeCase.settlement_amt | moneyFormatter }}</h4>
            </b-col>
            <b-col class="border-right">
                <p>Total Disbursed. (RM)</p>
                <h4>{{ activeCase.disb_total_amt | moneyFormatter }}</h4>
            </b-col>
            <b-col>
                <p>Remaining Amt. (RM)</p>
                <h4>{{ activeCase.disb_pending_amt | moneyFormatter }}</h4>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore'

export default {
data() {
	return {
		currentStatus: {},
		statusList: []
	}
},
computed: {
	...mapState(useLoanCaseStore, ['activeCase']),
	...mapState(useCommonStore, ['allStatus']),
	is_loading(){
		return _gHlp.isEmpty(this.activeCase)
	}
},
watch: {
	'activeCase': {
		handler(newValue, oldValue) {
			this.setStatusList()
		},
		immediate: true
	},
	'allStatus': {
		handler(newValue, oldValue) {
			this.setStatusList()
		},
		immediate: true
	}
},
methods: {
	setStatusList() {
		if (!_gHlp.isEmpty(this.allStatus)) {
			this.statusList = this.allStatus.filter(itm => itm.module == 'disbursement');
			this.setCurrentStatus();
		}
	},
	setCurrentStatus() {
		if (!_gHlp.isEmpty(this.allStatus) && !_gHlp.isEmpty(this.activeCase)) {
			this.currentStatus = this.allStatus.find(itm => itm.id == this.activeCase.disb_status_id);
		}
		if (_gHlp.isEmpty(this.currentStatus)) {
			this.currentStatus = { id: null, name: "No Status", color_class: "text-grey" }
		}
	},
}	
}
</script>